module.exports = __webpack_public_path__ + "static/media/teaching.44e01f21.jpg";